export const SEED = 'EF';
